import { render, staticRenderFns } from "./ButtonUpdate.vue?vue&type=template&id=5fb1f4c2&scoped=true&"
import script from "./ButtonUpdate.vue?vue&type=script&lang=js&"
export * from "./ButtonUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ButtonUpdate.vue?vue&type=style&index=0&id=5fb1f4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb1f4c2",
  null
  
)

export default component.exports